
import { apiInstance } from '@/shared/api'

import type { UserData } from './types'

import { GET_USER_DATA } from './constants'



export function getUserData() {
    return apiInstance.get(`${GET_USER_DATA}`).json<UserData>()
}
